export default __webpack_public_path__ + "static/media/React-icon.cc18e3dd.svg";